function toggleCart() {
  const container = document.querySelector('#CartContainer')
  if (container.classList.contains('is-open')) {
    container.querySelector('.cart').style.transform = 'translateX(100%)'
    setTimeout(() => {
      container.classList.remove('is-open')
      document.body.style.overflow = ''
    document.body.classList.remove('upcartPopupShow')
    }, 350)
  } else {
    container.classList.add('is-open')
    document.body.style.overflow = 'hidden'
    setTimeout(() => {
      container.querySelector('.cart').style.transform = 'translateX(0%)'
    }, 0)
  }
}

let upgradeFromVariantId = ''
let upgradeBlock = null

function bodyOverflow() {
  setTimeout(() => {
    document.body.style.overflow = 'hidden'
  }, 500)
  window.removeEventListener('transitionend', bodyOverflow)
}

let productObserver = null
let hasSetupListener = false

document.addEventListener('DOMContentLoaded', () => {
  document.querySelector('#AddToCart').onclick =() => {
    console.log('add cart')
    const id = document.querySelector('select[name="id"]').value

    CartJS.addItem(id, 1)
  }
  if (document.querySelector('#AddToCart')) {
    productObserver = new MutationObserver((mutations) => {
      if (mutations.find(item => item.target.querySelector('#AddToCart'))) {
        console.log(document.querySelector('#AddToCart'))
        document.querySelector('#AddToCart').onclick =() => {
          console.log('add cart')
          const id = document.querySelector('select[name="id"]').value

          CartJS.addItem(id, 1)
        }
      }
    })
    productObserver.observe(document.querySelector('.main-content'), {
      subtree: true,
      childList: true,
      attributes: true
    })
  }

  document.querySelectorAll(['.cart__underlay', '.close-cart']).forEach(item => item.addEventListener('click', (event) => {
    console.log('add cart toggle')
    event.preventDefault()
    event.stopPropagation()
    event.stopImmediatePropagation()
    toggleCart()
  }))
})

if (!customElements.get('open-cart')) {
  customElements.define('open-cart', class OpenCart extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('click', () => {
        toggleCart()
      })
    }
  })
}

if (!customElements.get('cart-item')) {
  customElements.define('cart-item', class CartItem extends HTMLElement {
    constructor() {
      super();

      this.querySelector('.price-remove .remove').addEventListener('click', (event) => {
        event.target.classList.add('free-gift-loading')

        CartJS.removeItem(event.target.closest('cart-item').getAttribute('data-line'))
      })

      this.querySelector('.qty-wrapper .minus').addEventListener('click', () => {
        this.querySelector('input').stepDown()
        this.updateQuantity()
      })
      this.querySelector('.qty-wrapper .plus').addEventListener('click', () => {
        this.querySelector('input').stepUp()
        this.updateQuantity()
      })
    }

    timeout = null

    updateQuantity() {
      if (this.timeout) {
        return
      }

      this.timeout = setTimeout(() => {
        this.querySelector('.price-remove .remove').classList.add('free-gift-loading')
        CartJS.updateItem(this.getAttribute('data-line'), this.querySelector('input').value)
        this.timeout = null
      }, 300)
    }
  })
}

if (!customElements.get('cart-header')) {
  customElements.define('cart-header', class CartHeader extends HTMLElement {
    constructor() {
      super();

      this.querySelector('.close-cart').addEventListener('click', event => {
        toggleCart()
      })
    }
  })
}
